import { Skeleton } from "@tellescope/ui";
import { Card } from "@tellescope/design-system";

export const InvoiceCardSkeleton = () => {
  return (
    <Card variant="floating" padding="root">
      <Card.Body className="px-4">
        <div className="flex gap-3 items-center">
          <div className="flex-shrink-0">
            <Skeleton className="w-10 h-10 rounded-lg" />
          </div>
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-3 w-1/3" />
          </div>
          <div className="flex gap-1">
            <Skeleton className="w-8 h-8 rounded" />
            <Skeleton className="w-8 h-8 rounded" />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
